import React from "react";

interface TrendingIconProps {
  size?: number | string;
  color?: string;
}
const TrendingIcon = ({ size, color = "#002035" }: TrendingIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
    <path d="M11.9999 4.80821H11.4244V1.07544H7.69189V0.5H11.9999V4.80821Z" fill={color} />
    <path
      d="M0.406952 9.0784L0 8.67167L3.93602 4.73566L5.79699 6.59663L11.5038 0.589722L11.9208 0.985855L5.80758 7.4209L3.93602 5.54933L0.406952 9.0784Z"
      fill={color}
    />
  </svg>
);

export default TrendingIcon;
